
















import { Component, Mixins, Prop } from "vue-property-decorator";
import { OptionDropDownSelector } from "../../../../../base/components/system/selectors";
import { ModelEditableMixin } from "../../../../../base/components/system/mixins";
import { IDateStyle, DateFormatKinds } from "../../../../../documaker/domain/format/objects";
import { StandardOption } from "../../../../../base/components/system/selectors/mixins";

@Component({
  components: {
    OptionDropDownSelector,
  }
})
export default class DateStyleEditor extends Mixins(ModelEditableMixin) {
  @Prop({default: () => ({
    formatKind: {
      isEnable: true,
    },
    hasWeekDay: {
      isEnable: true,
    },
  })})
  option: {
    formatKind: {
      isEnable: boolean;
    },
    hasWeekDay: {
      isEnable: boolean;
    },
  };

  writePropertyWhenValid: (writer: (source: IDateStyle) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: IDateStyle) => T, defaultValue: T) => T;

  get formatKind(): DateFormatKinds {
    return this.readPropertyOrDefault(s => s.formatKind, DateFormatKinds.ymdStringAd);
  }

  set formatKind(value: DateFormatKinds) {
    this.writePropertyWhenValid(s => s.formatKind = value);
  }

  get hasWeekDay(): boolean {
    return this.readPropertyOrDefault(s  => s.hasWeekDay, false);
  }

  set hasWeekDay(value: boolean) {
    this.writePropertyWhenValid(s => s.hasWeekDay = value);
  }

  formatKindOptions: StandardOption<number>[] = [
    new StandardOption<number>("年月日(西暦)", DateFormatKinds.ymdStringAd),
    new StandardOption<number>("年月日(和暦年号あり)", DateFormatKinds.ymdStringJcEra),
    new StandardOption<number>("年月日(和暦年号なし)", DateFormatKinds.ymdStringJc),
    new StandardOption<number>("年/月/日(西暦)", DateFormatKinds.ymdSlashAd),
    new StandardOption<number>("年/月/日(和暦年号記号)", DateFormatKinds.ymdSlashJcE),
    new StandardOption<number>("年.月.日(西暦)", DateFormatKinds.ymdDotAd),
    new StandardOption<number>("年.月.日(和暦年号記号)", DateFormatKinds.ymdDotJcE),
    new StandardOption<number>("年月(西暦)", DateFormatKinds.ymStringAd),
    new StandardOption<number>("年月(和暦年号あり)", DateFormatKinds.ymStringJcEra),
    new StandardOption<number>("年月(和暦年号なし)", DateFormatKinds.ymStringJc),
    new StandardOption<number>("年.月(和暦年号記号)", DateFormatKinds.ymDotJcE),
    new StandardOption<number>("月日", DateFormatKinds.mdStringAd),
    new StandardOption<number>("月/日", DateFormatKinds.mdSlashAd),
    new StandardOption<number>("和暦年号のみ", DateFormatKinds.jcEra),
    new StandardOption<number>("和暦年号記号のみ", DateFormatKinds.jcE),
  ];
}
